<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  modelValue: boolean
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'change'): void
}>()

const isGrouped = computed({
  get: () => props.modelValue,
  set: (value: boolean) => {
    emit('update:modelValue', value)
  },
})

const sliderClasses = computed(() => ({
  'app-switch-slider': true,
  'bg-primary': isGrouped.value,
}))

const handleChange = () => {
  emit('change')
}
</script>

<template>
  <div class="px-3 py-2 bg-light border-top border-bottom d-flex justify-content-between align-items-center">
    <span class="text-muted font-weight-bold fs-12">{{ $t('notification.list.groupByType') }}</span>
    <label class="app-switch mb-0">
      <input type="checkbox" v-model="isGrouped" @change="handleChange" />
      <span :class="sliderClasses"></span>
    </label>
  </div>
</template>

<style lang="scss" scoped>
.app-switch {
  position: relative;
  display: inline-block;
  width: 1.6rem;
  height: 0.9rem;
  cursor: pointer;

  input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  .app-switch-slider {
    position: absolute;
    inset: 0;
    background-color: #d1d9e0;
    border-radius: 1rem;
    transition: background-color 0.2s ease-in-out;

    &::before {
      content: '';
      position: absolute;
      top: 0.1rem;
      left: 0.1rem;
      width: 0.7rem;
      height: 0.7rem;
      background-color: #ffffff;
      border-radius: 50%;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
      transition: transform 0.2s ease-in-out;
    }
  }

  input:checked + .app-switch-slider::before {
    transform: translateX(0.7rem);
  }

  input:focus-visible + .app-switch-slider {
    outline: 2px solid;
    outline-offset: 2px;
  }
}
</style>
